import React from 'react';

// MUI
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Fab } from '@mui/material';

// Icons
import { Close } from '@mui/icons-material';
import makeStyles from '@mui/styles/makeStyles';
import { UPLOAD__FILE_TYPE, UPLOAD_MAX_IMAGE_SIZE } from 'config/config';
import { DropzoneArea } from 'react-mui-dropzone';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(theme => ({
  marginTop10: {
    marginTop: 10,
  },
  modalCloseButton: {
    float: 'right',
    marginTop: -6,
  },
  modalTitle: {
    minimumHeight: 50,
  },
}));

const SupportFileUploadModal = ({ show, onClose, handleAddFile }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const handleDropFileArea = files => {
    if (files.length > 0) {
      handleAddFile(files);
      onClose();
    }
  };
  if (!show) return null;

  return (
    <Dialog
      open={show}
      maxWidth={'lg'}
      fullWidth={true}
      onClose={onClose}
      aria-labelledby="max-width-dialog-title"
      aria-describedby="modal-slide-description">
      <DialogTitle>
        <Fab size="small" className={classes.modalCloseButton} key="close" aria-label="Close" onClick={onClose}>
          <Close className={classes.modalClose} />
        </Fab>
        <h2 className={classes.modalTitle}>{t('upload_files')}</h2>
        <Divider className={classes.marginTop10} />
      </DialogTitle>
      <DialogContent id="modal-slide-description" className={classes.modalBody}>
        <DropzoneArea
          maxFileSize={UPLOAD_MAX_IMAGE_SIZE}
          acceptedFiles={UPLOAD__FILE_TYPE}
          showPreviewsInDropzone={false}
          showAlerts={false}
          onChange={files => {
            handleDropFileArea(files);
          }}
          Icon={() => <></>}
          dropzoneText={t('drag_and_drop_files')}
          dropzoneClass={classes.dropzone}
        />
      </DialogContent>
      <DialogActions className={classes.modalFooter}>
        <Button onClick={onClose} color="primary">
          {t('close')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default SupportFileUploadModal;
